import { VFC } from 'react'
import styled from 'styled-components'

type Props = {
  value: boolean
  onChange: (v: boolean) => unknown
}

export const ToggleSwitch: VFC<Props> = ({ value, onChange }) => {
  return (
    <Wrapper value={value} onClick={() => onChange(!value)}>
      <Dot value={value} />
    </Wrapper>
  )
}

const Wrapper = styled.div<{ value: boolean }>`
  cursor: pointer;
  border-radius: 100px;
  display: flex;
  flex-direction: ${(props) => (props.value ? 'row-reverse' : 'row')};
  align-items: center;
  position: relative;
  height: 16px;
  width: 40px;
  background: ${(props) => (props.value ? '#F8E4D4' : '#CDCDCD')};
`

const Dot = styled.div<{ value: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 100px;
  transform: translateY(-50%);
  position: absolute;
  top: 50%;
  ${(props) => (props.value ? 'right: 0;' : 'left: 0')};
  background: ${(props) => (props.value ? '#FF6C01;' : '#fff')};
  border: ${(props) => (props.value ? 'none' : 'solid 1px #ccc')};
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.1);
`
